<Modal
  title="Verify email"
  actionTitle="Confirm"
  {isLoading}
  on:close={() => ($uiState.activeModal = undefined)}
  on:action={() => apply()}>
  <p class="block">The user will not need to verify their email address.</p>

  {#if errorMessage}
    <div class="block notification is-danger is-light">{errorMessage}</div>
  {/if}
</Modal>

<script lang="ts">
  export let userId :string;

  import { logging } from '../../../../../lib/logging';
  import { uiState } from "../../../../../lib/uiState";
  import Modal from "../../../../_components/Modal.svelte";

  let errorMessage :string;
  let isLoading :boolean;

  async function apply() {
    isLoading = true;

    let firebase = window.firebase;

    await firebase
      .functions()
      .httpsCallable('api-account-verifyemail')({ email: userId } as VerifyEmailParams)
      .then(() => {
        $uiState.activeModal = undefined;
        window.location.reload(); // crude, but modals do not yet trigger events on parent page when closed/finished
      })
      .catch((err) => {
        logging.report(err.toString());
        errorMessage = err;
      })
      .finally(() => (isLoading = false));
  }
</script>
